import md5 from "./common/md5.js";
import common from "./comm.js";
import router from "../../router/router.js";
import Api from "@/assets/js/API/api.js";

// appid和密钥
let appid = common.appid;
let appsecret = common.appsecret;

// 获取域名
function getDomainName() {
  let domain = location.host || "";
  if (common.serve_s == "dev") {
    domain = common.domain || "";
  }
  return domain;
}

// 获取企业编号
function getEnterpriseNo() {
  let EnterpriseNo = window.localStorage.getItem("EnterpriseNo") || "";
  // let EnterpriseNo = 'huayuan1001'  //集运
  // let EnterpriseNo = 'bamibuytest'     //代购
  return EnterpriseNo;
}

// 获取当前语言代码
function getLanguageCode() {
  let code = navigator.language || navigator.userLanguage;
  if (common.serve_s == "dev") {
    code = "zh-CN";
  }
  return code;
}

/**
 * 获取浏览器url中的参数
 */
function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return "";
}

// 处理参数,变成我想要的对象数组
function getSignArr(param) {
  let arr = [];
  for (let k in param) {
    let obj = {
      key: k,
      val: param[k],
    };
    arr.push(obj);
  }
  return arr;
}

// 获取md5加密签名(直接传个对象{name:'张三'})
function getSign(param) {
  let arrs = [];
  for (let k in param) {
    let val1 = param[k];
    if (val1 === null) {
      val1 = "";
    }
    if (val1 === 0 || val1 === "0") {
    } else {
      val1 = param[k] || "";
    }
    let obj = {
      key: k,
      val: val1,
    };
    if (obj.k !== "sign") {
      arrs.push(obj);
    }
  }
  var sign = appsecret;
  //排序
  let datas = arrs || [];
  let sortArr = arrs || [];
  var newArr = [];
  for (var j = 0; j < sortArr.length; j++) {
    newArr.push(sortArr[j].key);
  }
  let arrSort = newArr.sort();
  let endArr = [];
  for (var s = 0; s < arrSort.length; s++) {
    for (var d = 0; d < datas.length; d++) {
      if (arrSort[s] == datas[d].key) {
        endArr.push(datas[d]);
      }
    }
  }

  if (endArr.length == 0) {
    return;
  }
  //是否开启打印
  let showLog = false;
  // let showLog = true;
  if (showLog) {
    console.log("加密前 sign:=====" + sign);
  }

  for (var i = 0; i < endArr.length; i++) {
    let val = JSON.stringify(endArr[i].val);
    if (!isJSON(val)) {
      val = endArr[i].val + "";
    } else {
      val = "object";
    }
    //
    if (showLog) {
      console.log(
        i +
        "_" +
        i +
        "   " +
        ">> key:=(" +
        endArr[i].key +
        ") >> val:=( " +
        val +
        " ) >>Ascii:==( " +
        getCharCodeArr(val)
      ) + " )";
    }

    sign = md5.hex_md5(endArr[i].key + getCharCodeArr(val) + sign);
    //
    if (showLog) {
      console.log("第" + i + "次的sign :  " + sign);
    }
  }
  sign = md5.hex_md5(sign + appid);
  //
  if (showLog) {
    console.log("最终结果:  " + sign);
  }

  return sign; //
}
// 判断是否是jsop
function isJSON(str) {
  if (typeof str == "string") {
    try {
      var obj = JSON.parse(str);
      if (typeof obj == "object" && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log("error：" + str + "!!!" + e);
      return false;
    }
  }
}

function getCharCodeArr(str) {
  let strArr = str.split("");
  let strEnd = "";
  for (var i = 0; i < strArr.length; i++) {
    let code = strArr[i].charCodeAt();
    strEnd = strEnd + "" + code;
  }
  return strEnd;
}

//当前年月日时分秒
function getCurrentTime() {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hours = date.getHours();
  let min = date.getMinutes();
  let sec = date.getSeconds();

  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;
  hours = hours < 10 ? "0" + hours : hours;
  min = min < 10 ? "0" + min : min;
  sec = sec < 10 ? "0" + sec : sec;
  let sdate =
    year + "-" + month + "-" + day + " " + hours + ":" + min + ":" + sec;
  return sdate;
}
//当前年月日
function getCurrentDate() {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;
  let sdate = year + "-" + month + "-" + day;
  return sdate;
}

// 获取前num天或者后num天 时间
function getFlexDate(num) {
  let num1 = num || 0;
  var date1 = new Date(), //今天
    date2 = new Date(date1);
  date2.setDate(date1.getDate() + num1); //今天的前或者后几天
  // console.log('date2-----' + date2);

  var fixedM = date2.getMonth() + 1,
    fixedD = date2.getDate();

  fixedM = fixedM < 10 ? "0" + fixedM : fixedM;
  fixedD = fixedD < 10 ? "0" + fixedD : fixedD;
  var time2 = date2.getFullYear() + "-" + fixedM + "-" + fixedD;
  return time2;
}
//根据非数字字母切割多个单号
function getOrderNum(srt) {
  var String = [];
  var NewArr = [];
  if (srt.length < 1) {
    // console.log('return')
    return NewArr;
  }

  let flag = /[^-0-9A-Za-z]+/;
  String = srt.split(flag);

  for (var i = 0; i < String.length; i++) {
    if (String[i]) {
      NewArr.push(String[i]);
    }
  }
  return NewArr;
}

// ==========================精度计算 开始==============================================
/*
 * 判断obj是否为一个整数
 */
function isInteger(obj) {
  return Math.floor(obj) === obj;
}

/*
 * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
 * @param floatNum {number} 小数
 * @return {object}
 *   {times:100, num: 314}
 */
function toInteger(floatNum) {
  var ret = {
    times: 1,
    num: 0,
  };
  if (isInteger(floatNum)) {
    ret.num = floatNum;
    return ret;
  }
  var strfi = floatNum + ""; //转字符串
  var dotPos = strfi.indexOf("."); //获取小数点下标
  var len = strfi.substr(dotPos + 1).length; //小数点后有几位
  var times = Math.pow(10, len); //10的len次方
  var intNum = parseInt(floatNum * times + 0.5, 10);
  ret.times = times;
  ret.num = intNum;
  return ret;
}

/*
 * 核心方法，实现加减乘除运算，确保不丢失精度
 * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
 *
 * @param a {number} 运算数1
 * @param b {number} 运算数2
 * @param op {string} 运算类型，有加减乘除（add/sub/mul/divide）
 *
 */
function operation(a, b, op) {
  var o1 = toInteger(a);
  var o2 = toInteger(b);
  var n1 = o1.num;
  var n2 = o2.num;
  var t1 = o1.times;
  var t2 = o2.times;
  var max = t1 > t2 ? t1 : t2;
  var result = null;
  switch (op) {
    case "add": //加法
      if (t1 === t2) {
        // 两个小数位数相同
        result = n1 + n2;
      } else if (t1 > t2) {
        // o1 小数位 大于 o2
        result = n1 + n2 * (t1 / t2);
      } else {
        // o1 小数位 小于 o2
        result = n1 * (t2 / t1) + n2;
      }
      return result / max;
    case "sub": //减法
      if (t1 === t2) {
        result = n1 - n2;
      } else if (t1 > t2) {
        result = n1 - n2 * (t1 / t2);
      } else {
        result = n1 * (t2 / t1) - n2;
      }
      return result / max;
    case "mul": //乘法
      result = (n1 * n2) / (t1 * t2);
      return result;
    case "divide": //除法
      result = (n1 / n2) * (t2 / t1);
      return result;
  }
}

// 加
function add(a, b) {
  return operation(a, b, "add");
}
//减
function sub(a, b) {
  return operation(a, b, "sub");
}
//乘
function mul(a, b) {
  return operation(a, b, "mul");
}
//除
function divide(a, b) {
  return operation(a, b, "divide");
}
// 四合五入  (计算金额用这个)
function mathRound(number) {
  return Math.round(number * 100) / 100; // 成功转成1.54
}
// 保留几位小数    (偶尔会出现没有四舍五入的问题,例如谷歌浏览器下 1.535 不会四舍五入,1.635.toFixed(2)可以)
function mathToFixed(number, num = 2) {
  return number.toFixed(num); // 成功转成1.54
}
// ==========================精度计算 结束==============================================

function updateQueryStringParameter(uri, key, value) {
  if (!value) {
    return uri;
  }
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return uri + separator + key + "=" + value;
  }
}

//关闭当前页面,跳转指定页面 (this.reload()要在具体页面用)
function closePage(that, goRoute) {
  // let currentRoute = router.fullPath
  let currentRoute = router.history.current.fullPath;
  if (currentRoute.indexOf("?") !== -1) {
    currentRoute = currentRoute.substr(0, currentRoute.indexOf("?"));
  }

  let arrs = JSON.parse(window.sessionStorage.editableTabs);
  arrs.forEach((item, index) => {
    if (item.path == currentRoute) {
      arrs.splice(index, 1);
    }
  });
  window.sessionStorage.setItem("editableTabs", JSON.stringify(arrs));
  // if (goRoute) {
  //   router.push(goRoute);
  // } else {
  //   // router.go(-1);
  // }
  // if (that) {
  //   that.reload();
  // }
  //   let newurl = updateQueryStringParameter(window.location.href, "isreload", "isreload");
  //   //向当前url添加参数，没有历史记录
  //   window.history.replaceState(
  //     {
  //       path: newurl,
  //     },
  //     "",
  //     newurl
  //   );
}
// 导出数据
function dynamicExport(myTableHeard, className, tableData, sheetName) {
  let heads = myTableHeard;
  let tableDatas = tableData || "";
  let newHeads = [];
  for (var i = 0; i < heads.length; i++) {
    let objs = {
      fieldKey: heads[i].field,
      title: heads[i].name,
    };
    newHeads.push(objs);
  }
  let param = {
    className: className || "",
    data: JSON.stringify(tableDatas),
    head: newHeads,
    sheetName: sheetName || "表名",
  };
  // let sign = tools.getSign(param);
  // param.sign = sign;
  Api.dynamicExport(param).then((res) => {
    let downloadurl = res.data.result.fileUrl || "";
    //下载(这里其实是直接访问)
    var a = document.createElement("a");
    a.setAttribute("href", downloadurl);
    a.setAttribute("target", "_blank");
    a.download = sheetName;
    a.click();

    // var x = new XMLHttpRequest();

    // x.open("GET", downloadurl, true);
    // x.responseType = 'blob';
    // x.onload = function (e) {
    //     var url = window.URL.createObjectURL(x.response)
    //     var a = document.createElement('a');
    //     a.href = url
    //     a.download = sheetName;
    //     a.click()
    // }
    // x.send();
  });
}

//  设置模板按钮
function myModel(that) {
  that.show_sortTableHeard = true;
  that.tabelHeadeTitle = JSON.parse(JSON.stringify(that.myTableHeard));
  let selectLength = 0;
  for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
    if (that.tabelHeadeTitle[i].isShow) {
      selectLength++;
    }
  }
  that.selectLength = selectLength;
  if (selectLength === that.tabelHeadeTitle.length) {
    that.allCheck = true;
  } else {
    that.allCheck = false;
  }
}
//    -------------  设置列表表头方法  ------------

function getGroupFindFieldSort(that, pageGroupName) {
  // 下面四個字段 對應的頁面要有,而且要一样
  // myTableHeard,sortName,tabelHeadeTitle,totalArr
  //  获取自定义的排序,没有就用默认的
  that.$API
    .getGroupFindFieldSort({
      groupName: pageGroupName, //当前页面表格的标记(自定义字符串)
    })
    .then((res) => {
      let arr = res.data.result || [];
      if (arr.length > 0) {
        if (arr[0].sortObject) {
          that.myTableHeard = JSON.parse(arr[0].sortObject);
          that.sortName = arr[0].sortName;
        }
      } else {
        that.myTableHeard = that.tabelHeadeTitle;
      }
      let totalArr = [];
      //提取需要合计的字段
      for (var i = 0; i < that.myTableHeard.length; i++) {
        if (that.myTableHeard[i].isTotal) {
          totalArr.push(that.myTableHeard[i].field);
        }
      }
      that.totalArr = totalArr;
    });
  that.$nextTick(() => {
    // 兼容写法 判断flag为true是天龙表格调用，false liuxiang的
    let flag = that.$refs.mytable.doLayout;
    if (flag) {
      that.$refs.mytable.doLayout();
    } else {
      that.$refs.mytable.$refs.tables.doLayout();
    }
  });
}

// 获取下拉状态
async function getStatusValList(val) {
  let resData = "";
  await Api.getStatusValList({ tableAndFieldName: val })
    .then((res) => {
      resData = res.data.result || [];
    })
    .catch((error) => { });

  return resData;
}
function debounce(func, wait = 500, immediate = false) {
  //防抖 是指在事件触发n秒后再执行回调，如果在n秒内再次被触发，则重新计算时间。（
  // 缓存一个定时器id
  let timer = 0;
  // 这里返回的函数是每次用户实际调用的防抖函数
  // 如果已经设定过定时器了就清空上一次的定时器
  // 开始一个新的定时器，延迟执行用户传入的方法
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}
//把方法暴露出去
export default {
  debounce,
  getDomainName,
  getLanguageCode,
  getUrlParam,
  getSignArr,
  getFlexDate,
  getCurrentTime,
  getCurrentDate,
  getSign,
  getOrderNum,
  mathToFixed,
  mathRound,
  divide,
  mul,
  sub,
  add,
  closePage,
  dynamicExport,
  myModel,
  getGroupFindFieldSort,
  getStatusValList,
  getEnterpriseNo,

  // 重置表单
  resetForm(that, formName) {
    that.$refs[formName].resetFields();
  },

  // 加法(计算数组里面的和)
  getAddMathNumber(Arr) {
    let arr = Arr || [];
    let num = 0;
    arr.forEach((item) => {
      num = add(item * 1, num);
    });
    return num.toFixed(3);
  },
  // 删除全字段查询数组多余的字段
  delMorField(arr1, arr2) {
    for (var a = 0; a < arr1.length; a++) {
      arr1[a].isList = false;
      for (var b = 0; b < arr2.length; b++) {
        if (arr1[a].field == arr2[b].val) {
          arr1[a].isList = true;
        }
        if (arr1[a].field == arr2[b].valShow) {
          arr1.splice(a, 1);
          a--;
        }
      }
    }
    return arr1;
  },
  // 跳转运单详情
  goYdDetails(row) {
    // this.$message.success("你点我干嘛");
    router.push({
      path: "/WaybillManage/WaybillDetails",
      query: {
        waybillSplitId: row.waybillSplitId,
        waybillNumber: row.waybillNumber,
        orderNumber: row.orderNumber,
      },
    });
  },
  getUserInfo() {
    let userInfo = window.localStorage.getItem("userInfo") || "";
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
    }
    return userInfo;
  },

  isInit({ pageType, isreloads }) {
    let flag = true
    if (pageType == "isTabs" || isreloads == "isreload") {
      flag = false
    }

    return flag
  }
};
